import { render, staticRenderFns } from "./ShopcarView.vue?vue&type=template&id=2d0ab5da&scoped=true&"
import script from "./ShopcarView.vue?vue&type=script&lang=js&"
export * from "./ShopcarView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0ab5da",
  null
  
)

export default component.exports